import {
  GET_UNIT_LIST_BY_BUILDING_ID,
  GetUnitsByBuildingIdResponseDto, UnitListByBuildingId,
} from '../../configs/APISchemas/GetUnitListByBuildingId';
import { GraphQLRequest } from '../GraphQLRequest';
import { useCallback, useState } from 'react';

export const useUnitListByBuildingId = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getUnitListByBuildingId = useCallback(async (buildingId: string): Promise<UnitListByBuildingId | null> => {
    try {
      setIsLoading(true);
      const query = GET_UNIT_LIST_BY_BUILDING_ID(buildingId);

      const { getStoredUnitsByBuildingId } = await GraphQLRequest<GetUnitsByBuildingIdResponseDto>(query, {
        typeOfQuery: 'GET_UNIT_LIST_BY_BUILDING_ID',
      });

      setIsLoading(false);

      return { ...getStoredUnitsByBuildingId };
    } catch (e) {
      setIsLoading(false);
      return null;
    }
  }, []);


  return {
    isLoading,
    getUnitListByBuildingId,
  };
};
